export function AboutPage() {
  return (
    <section className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-gray-900 mb-6">About ColorCraft</h1>
      <div className="prose prose-lg text-gray-600">
        <p className="text-xl mb-6">
          ColorCraft transforms any image into beautiful, printable coloring pages
          using AI-powered line art conversion.
        </p>
        <p className="mb-6">
          Tired of searching through dodgy websites for coloring pages? ColorCraft provides
          a safe, ad-free environment where you can create custom coloring pages from your
          own photos, favorite characters, or any image you find.
        </p>
        <div className="bg-indigo-50 rounded-2xl p-6 border border-indigo-100">
          <h3 className="text-xl font-semibold text-gray-900 mb-3">What You Can Do</h3>
          <ul className="space-y-2 text-gray-700">
            <li>• Convert any photo to line art</li>
            <li>• Export as scalable SVG for any page size</li>
            <li>• Clean up existing coloring pages</li>
            <li>• Remove watermarks from images</li>
            <li>• Tag and organize your collection</li>
            <li>• Search by theme or category</li>
          </ul>
        </div>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Technology</h2>
        <p className="mb-6">
          ColorCraft uses advanced computer vision algorithms including Canny edge detection
          and image inpainting to process your images. The application is built with:
        </p>
        <ul className="space-y-2 text-gray-700 mb-6">
          <li>• <strong>Frontend:</strong> React 19 + TypeScript + Tailwind CSS</li>
          <li>• <strong>Backend:</strong> .NET 9 Web API + Entity Framework Core</li>
          <li>• <strong>Image Processing:</strong> OpenCvSharp + ImageSharp</li>
          <li>• <strong>Database:</strong> SQL Server</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Privacy</h2>
        <p className="mb-6">
          Your images are processed locally on your own machine. No images are sent to
          external servers or used for training AI models. You maintain full control and
          ownership of all your coloring pages.
        </p>
      </div>
    </section>
  );
}
